(function () {

    angular
        .module('app')
        .service('qitanAiContractService', qitanAiContractService);

    qitanAiContractService.$inject = [
        '$http'
    ];

    function qitanAiContractService($http) {
        var QITAN_AI_RUNTIME_CONFIG = '/api/qitan-ai/runtime-config';
        var QITAN_AI_MODEL_CONFIG = '/api/qitan-ai/model-config';
        var QITAN_AI_PLUGIN_CAPABILITIES = '/api/qitan-ai/plugin/capabilities';
        var QITAN_AI_PLUGIN_INVOKE = '/api/qitan-ai/plugin/:abilityId';
        var QITAN_AI_STUDIO_SSO = '/api/qitan-ai/studio-sso';
        var QITAN_AI_CLASSROOM_INVOKE = '/api/classes/:classid/qitan-ai/invoke';
        var QITAN_AI_CODING_WORKBENCH = '/api/qitan-ai/coding-workbench';
        var QITAN_AI_CAPABILITY_INSTANCE_INTERNAL_REFS = '/api/qitan-ai/internal/instances/:instanceid/refs';
        var endpoints = {
            runtimeConfig : QITAN_AI_RUNTIME_CONFIG,
            modelConfig : QITAN_AI_MODEL_CONFIG,
            pluginCapabilities : QITAN_AI_PLUGIN_CAPABILITIES,
            pluginInvoke : QITAN_AI_PLUGIN_INVOKE,
            studioSso : QITAN_AI_STUDIO_SSO,
            classroomInvoke : QITAN_AI_CLASSROOM_INVOKE,
            codingWorkbench : QITAN_AI_CODING_WORKBENCH,
            capabilityInstanceInternalRefs : QITAN_AI_CAPABILITY_INSTANCE_INTERNAL_REFS
        };
        var classroomApi = {
            currentSession : '/api/classes/:classid/classroom-sessions/current',
            sessions : '/api/classes/:classid/classroom-sessions',
            joinCode : '/api/classes/:classid/classroom-sessions/:sessionid/join-code',
            students : '/api/classes/:classid/classroom-sessions/:sessionid/students',
            join : '/api/classroom/join',
            wallet : '/api/classes/:classid/genai-wallet',
            walletPurchase : '/api/classes/:classid/genai-wallet/purchase',
            allocations : '/api/classes/:classid/genai-allocations',
            usage : '/api/classes/:classid/genai-usage',
            assignments : '/api/classes/:classid/classroom-sessions/:sessionid/assignments',
            submissions : '/api/classes/:classid/classroom-sessions/:sessionid/submissions',
            submission : '/api/classes/:classid/classroom-sessions/:sessionid/submissions/:submissionid',
            submissionArtifact : '/api/classes/:classid/classroom-sessions/:sessionid/submissions/:submissionid/artifact'
        };
        var authApi = {
            me : '/api/me',
            oidcConfig : '/api/oidc/config',
            oidcCallback : '/api/oidc/callback',
            oidcPasswordLogin : '/api/oidc/password-login',
            oidcSession : '/api/oidc/session',
            oidcLogout : '/api/oidc/logout',
            sessionUsers : '/api/sessionusers',
            sessionUser : '/api/classes/:classid/sessionusers/:studentid',
            localPreviewLogin : '/api/local-preview/login'
        };
        var classApi = {
            teachers : '/api/teachers',
            classes : '/api/classes',
            class : '/api/classes/:classid',
            tenantPolicy : '/api/classes/:classid/policy',
            students : '/api/classes/:classid/students',
            student : '/api/classes/:classid/students/:studentid',
            studentPassword : '/api/classes/:classid/students/:studentid/password',
            passwords : '/api/classes/:classid/passwords',
            credentials : '/api/classes/:classid/credentials',
            credential : '/api/classes/:classid/credentials/:credentialsid'
        };
        var projectApi = {
            modelSupport : '/api/classes/:classid/modelsupport/:type',
            allClassProjects : '/api/classes/:classid/projects',
            projects : '/api/classes/:classid/students/:studentid/projects',
            project : '/api/classes/:classid/students/:studentid/projects/:projectid',
            fields : '/api/classes/:classid/students/:studentid/projects/:projectid/fields',
            labels : '/api/classes/:classid/students/:studentid/projects/:projectid/labels',
            projectCrowdsourced : '/api/classes/:classid/students/:studentid/projects/:projectid/iscrowdsourced',
            localProjects : '/api/classes/:classid/students/:studentid/localprojects',
            localProject : '/api/classes/:classid/students/:studentid/localprojects/:projectid'
        };
        var trainingApi = {
            trainingItems : '/api/classes/:classid/students/:studentid/projects/:projectid/training',
            trainingItem : '/api/classes/:classid/students/:studentid/projects/:projectid/training/:trainingid',
            prepareImages : '/api/classes/:classid/students/:studentid/training/images',
            prepareNgrams : '/api/classes/:classid/students/:studentid/training/ngrams',
            images : '/api/classes/:classid/students/:studentid/projects/:projectid/images',
            image : '/api/classes/:classid/students/:studentid/projects/:projectid/images/:imageid',
            sounds : '/api/classes/:classid/students/:studentid/projects/:projectid/sounds',
            sound : '/api/classes/:classid/students/:studentid/projects/:projectid/sounds/:soundid'
        };
        var learningModelApi = {
            models : '/api/classes/:classid/students/:studentid/projects/:projectid/models',
            model : '/api/classes/:classid/students/:studentid/projects/:projectid/models/:modelid',
            modelTest : '/api/classes/:classid/students/:studentid/projects/:projectid/models/:modelid/label',
            localNumbersModels : '/api/classes/:classid/students/:studentid/localnumbersprojects',
            localModels : '/api/classes/:classid/students/:studentid/localprojects/:projectid/models',
            localModel : '/api/classes/:classid/students/:studentid/localprojects/:projectid/models/:modelid',
            localModelTest : '/api/classes/:classid/students/:studentid/localprojects/:projectid/models/:modelid/label',
            classifiers : '/api/classes/:classid/classifiers',
            classifier : '/api/classes/:classid/classifiers/:classifierid'
        };
        var scratchApi = {
            projectScratchKeys : '/api/classes/:classid/students/:studentid/projects/:projectid/scratchkeys',
            localProjectScratchKeys : '/api/classes/:classid/students/:studentid/localprojects/:projectid/scratchkeys',
            train : '/api/scratch/:scratchkey/train',
            image : '/api/scratch/:scratchkey/images/api/classes/:classid/students/:studentid/projects/:projectid/images/:imageid',
            classify : '/api/scratch/:scratchkey/classify',
            status : '/api/scratch/:scratchkey/status',
            model : '/api/scratch/:scratchkey/models',
            localModel : '/api/scratch/:scratchkey/local/models',
            extension3 : '/api/scratch/:scratchkey/extension3.js',
            smallLanguageModelExtension : '/api/scratch/:modelid/:contextwindow/extensionslm.js',
            tfjsExtension : '/api/scratch/:scratchkey/extensiontfjs.js',
            tfjsExtensions : '/api/scratchtfjs/extensions',
            extension3Local : '/api/scratch/:scratchkey/local/:projecttype/extension3.js',
            appInventorExtension : '/api/appinventor/:scratchkey/extension'
        };
        var siteAlertApi = {
            siteAlerts : '/api/sitealerts',
            public : '/api/sitealerts/public',
            student : '/api/sitealerts/alerts/:classid/students/:studentid',
            teacher : '/api/sitealerts/alerts/:classid/supervisors/:studentid',
            refresh : '/api/sitealerts/actions/refresh'
        };
        var routes = {
            courses : '#!/courses',
            assets : '#!/assets',
            capabilities : '#!/teacher/classroom',
            qitanAi : '#!/qitan-ai',
            qitanAiWorkspace : '#!/qitan-ai/workspace',
            codingLab : '#!/coding-lab',
            codingWorkbench : '#!/coding-lab/workbench'
        };
        var studio = {
            defaultNext : '/space'
        };
        function returnData(resp) {
            return resp.data;
        }

        function getStudioEntryUrl(nextPath) {
            return QITAN_AI_STUDIO_SSO + '?next=' + encodeURIComponent(nextPath || studio.defaultNext);
        }

        function getStudioLaunch(nextPath) {
            return $http.get(QITAN_AI_STUDIO_SSO, {
                params : {
                    next : nextPath || studio.defaultNext,
                    format : 'json'
                },
                headers : {
                    Accept : 'application/json'
                }
            }).then(returnData);
        }

        function getCodingWorkbenchEntryUrl() {
            return QITAN_AI_CODING_WORKBENCH;
        }

        function getCodingWorkbenchLaunch() {
            return $http.get(QITAN_AI_CODING_WORKBENCH, {
                params : {
                    format : 'json'
                },
                headers : {
                    Accept : 'application/json'
                }
            }).then(returnData);
        }

        function getClassroomInvokeUrl(classid) {
            return QITAN_AI_CLASSROOM_INVOKE.replace(':classid', encodeURIComponent(classid));
        }

        function buildPath(pathPattern, params) {
            return pathPattern.replace(/:([A-Za-z0-9_]+)/g, function (match, key) {
                if (!params || params[key] === undefined || params[key] === null) {
                    throw new Error('Missing API route parameter: ' + key);
                }
                return encodeURIComponent(params[key]);
            });
        }

        function getClassroomApiUrl(name, params) {
            if (!classroomApi[name]) {
                throw new Error('Unknown classroom API route: ' + name);
            }
            return buildPath(classroomApi[name], params || {});
        }

        function getAuthApiUrl(name, params) {
            if (!authApi[name]) {
                throw new Error('Unknown auth API route: ' + name);
            }
            return buildPath(authApi[name], params || {});
        }

        function getClassApiUrl(name, params) {
            if (!classApi[name]) {
                throw new Error('Unknown class API route: ' + name);
            }
            return buildPath(classApi[name], params || {});
        }

        function getProjectApiUrl(name, params) {
            if (!projectApi[name]) {
                throw new Error('Unknown project API route: ' + name);
            }
            return buildPath(projectApi[name], params || {});
        }

        function getTrainingApiUrl(name, params) {
            if (!trainingApi[name]) {
                throw new Error('Unknown training API route: ' + name);
            }
            return buildPath(trainingApi[name], params || {});
        }

        function getLearningModelApiUrl(name, params) {
            if (!learningModelApi[name]) {
                throw new Error('Unknown learning model API route: ' + name);
            }
            return buildPath(learningModelApi[name], params || {});
        }

        function getScratchApiUrl(name, params) {
            if (!scratchApi[name]) {
                throw new Error('Unknown Scratch API route: ' + name);
            }
            return buildPath(scratchApi[name], params || {});
        }

        function getSiteAlertApiUrl(name, params) {
            if (!siteAlertApi[name]) {
                throw new Error('Unknown site alert API route: ' + name);
            }
            return buildPath(siteAlertApi[name], params || {});
        }

        function getModelConfig() {
            return $http.get(QITAN_AI_MODEL_CONFIG).then(returnData);
        }

        function saveModelConfig(values) {
            return $http.put(QITAN_AI_MODEL_CONFIG, { values : values }).then(returnData);
        }

        function getRuntimeConfig(includeSecrets) {
            return $http.get(QITAN_AI_RUNTIME_CONFIG, {
                params : {
                    includeSecrets : includeSecrets ? '1' : '0'
                }
            }).then(returnData);
        }

        function getCapabilityInstanceInternalRefsUrl(instanceid) {
            return buildPath(QITAN_AI_CAPABILITY_INSTANCE_INTERNAL_REFS, {
                instanceid : instanceid
            });
        }

        function createCapabilityInstanceInternalRef(instanceid, payload, contextToken) {
            return $http.post(getCapabilityInstanceInternalRefsUrl(instanceid), payload, {
                headers : {
                    Authorization : 'Bearer ' + contextToken
                }
            }).then(returnData);
        }

        return {
            routes : routes,
            studio : studio,
            endpoints : endpoints,
            authApi : authApi,
            classApi : classApi,
            projectApi : projectApi,
            trainingApi : trainingApi,
            learningModelApi : learningModelApi,
            scratchApi : scratchApi,
            siteAlertApi : siteAlertApi,
            getStudioEntryUrl : getStudioEntryUrl,
            getStudioLaunch : getStudioLaunch,
            getCodingWorkbenchEntryUrl : getCodingWorkbenchEntryUrl,
            getCodingWorkbenchLaunch : getCodingWorkbenchLaunch,
            getClassroomInvokeUrl : getClassroomInvokeUrl,
            getClassroomApiUrl : getClassroomApiUrl,
            getAuthApiUrl : getAuthApiUrl,
            getClassApiUrl : getClassApiUrl,
            getProjectApiUrl : getProjectApiUrl,
            getTrainingApiUrl : getTrainingApiUrl,
            getLearningModelApiUrl : getLearningModelApiUrl,
            getScratchApiUrl : getScratchApiUrl,
            getSiteAlertApiUrl : getSiteAlertApiUrl,
            getModelConfig : getModelConfig,
            saveModelConfig : saveModelConfig,
            getRuntimeConfig : getRuntimeConfig,
            getCapabilityInstanceInternalRefsUrl : getCapabilityInstanceInternalRefsUrl,
            createCapabilityInstanceInternalRef : createCapabilityInstanceInternalRef
        };
    }
}());
